import { requests } from '../../../api/agent'

export default {
    getResponsiblesExecutPosition: (params) => requests.getWithParams('/ReResponsiblesExecutPosition/ListAllPaged', params),
    getResponsibleExecutPositionByName: (params) => requests.getWithParams('/ReResponsiblesExecutPosition/getByName', params),
    createResponsibleExecutPosition: (params) => requests.post('/ReResponsiblesExecutPosition/CreateResponsibleExecutPosition', params),
    deleteResponsibleExecutPosition: (params) => requests.post('/ReResponsiblesExecutPosition/DeleteResponsibleExecutPosition', params),
    updateResponsibleExecutPosition: (params) => requests.post('/ReResponsiblesExecutPosition/UpdateResponsibleExecutPosition', params),
    restoreResponsibleExecutPosition: (params) => requests.post('/ReResponsiblesExecutPosition/RestoreResponsibleExecutPosition', params)
}